import { Reducer, Action } from 'redux';
import { IRootState } from './index';
import { fork, takeEvery, call, select, put } from 'redux-saga/effects';
import { actionCreators as layoutActionCreators } from 'src/reducers/Layout';
import { selectors as authSelectors } from 'src/reducers/Auth';
import Api from '../api';
import { AnyObject } from 'final-form';

// Store
export interface IFileManagement {
    files: Array<File>;
    fileId: number;
    fileList: Array<AnyObject>;
}

const initialSate: IFileManagement = {
    files: undefined,
    fileId: undefined,
    fileList: undefined,
};

// Action Types
export enum actionTypes {
    UPLOAD_FILE = '[fileManagement] UPLOAD_FILE',
    UPLOAD_FILE_SUCCESS = '[fileManagement] UPLOAD_FILE_SUCCESS',
    GET_LIST = '[fileManagement] GET_LIST',
    GET_LIST_SUCCESS = '[fileManagement] GET_LIST_SUCCESS',
}

// Action Creators
export const actionCreators = {
    uploadFile: (payload: { projectId: number; file: File }) => {
        return { type: actionTypes.UPLOAD_FILE, payload };
    },
    uploadFileSuccess: (payload: number) => {
        return { type: actionTypes.UPLOAD_FILE, payload };
    },
    getList: () => {
        return { type: actionTypes.GET_LIST };
    },
    getListSuccess: (payload: Array<AnyObject>) => {
        return { type: actionTypes.GET_LIST_SUCCESS, payload };
    },
};

// Reducer
const reducer: Reducer<IFileManagement> = (state: IFileManagement = initialSate, action: Action): IFileManagement => {
    switch (action.type) {
        case actionTypes.UPLOAD_FILE_SUCCESS: {
            const payload = (action as { type: string; payload: number }).payload;
            return {
                ...state,
                fileId: payload,
            };
        }
        case actionTypes.GET_LIST_SUCCESS: {
            const payload = (action as { type: string; payload: Array<AnyObject> }).payload;
            return {
                ...state,
                fileList: payload,
            };
        }
        default:
            return state;
    }
};

export default reducer;

// Selectors
const fileIdSelector = (state: IRootState): number => state.fileManagement.fileId;

export const selectors = {
    fileId: fileIdSelector,
};

// Side-Effects
const sagas = {
    uploadFile: function* (action: { type: string; payload: { projectId: number; file: File } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { projectId, file } = action.payload;

        const formData = new FormData();
        formData.append('files', file, file.name);

        const result = yield call(Api.FileManagement.uploadFile, projectId, formData, jwt);

        console.log('result', result);

        // yield put(actionCreators.uploadFileSuccess(result));
    },
    getList: function* (action: { type: string }) {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);

        const result = yield call(Api.FileManagement.getList, jwt);

        yield put(actionCreators.getListSuccess(result));
    },
};

// Watches
const watches = {
    uploadFile: function* () {
        yield takeEvery(actionTypes.UPLOAD_FILE, sagas.uploadFile);
    },
    getList: function* () {
        yield takeEvery(actionTypes.GET_LIST, sagas.getList);
    },
};

// Forks
export function* saga() {
    yield fork(watches.uploadFile);
    yield fork(watches.getList);
}



// WEBPACK FOOTER //
// ./src/reducers/FileManagement.ts